'use client';

import type { EventBusListener } from '@hc-frontend/core-events';
import type { ButtonClickEvent } from '@hc-frontend/core-ui';
import { useEventBus } from '@hc-frontend/core-ui';
import { trackUserClick } from '@hc-frontend/third-party-snowplow';
import { usePathname } from 'next/navigation';
import { useCallback, useEffect } from 'react';

import { queryCategory } from '../link-events-subscription/link-events-subscription-lookup';

export function ButtonEventsSubscription() {
  const eventBus = useEventBus();
  const pathname = usePathname();

  const handleLinkClick = useCallback<EventBusListener<ButtonClickEvent>>(
    (event) => {
      if (event.source.hasAttribute('data-call-call-type')) {
        window.nbpix?.('event', 'call_button');
      }

      trackUserClick(
        {
          elementId: event.id,
          label: event.source.innerText,
          value: event.source.innerText,
          action: 'click',
          category: queryCategory(pathname),
          placement: 'content',
        },
        event.contexts,
      );
    },
    [pathname],
  );

  useEffect(() => {
    eventBus.subscribe('core.ui.button.click', handleLinkClick);

    return () => {
      eventBus.unsubscribe('core.ui.button.click', handleLinkClick);
    };
  }, [handleLinkClick, eventBus]);

  return null;
}
